function fetchDataLayer({ localBranch }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/analytics/dataLayer`;
  return apiClient.get(route, { query: { location: localBranch } });
}

export default { fetchDataLayer };
